import capitalize from '@/filters/capitalize.js';

/**
 * You can register global filters here and use them as a plugin in your main Vue instance
 */

const GlobalFilters = {
    install(Vue) {
        Vue.filter('capitalize', capitalize);
    }
};

export default GlobalFilters;
